import { http as robotHttp } from './http'

export const registerRobotProfile = data => robotHttp.post('/user/registerRobotProfile', data)

export const getMyRegisteredRobots = userId => robotHttp.get('/user/myRegisteredRobots', { params: { userId } })

export const cancelRegisteredRobot = data => robotHttp.post('/user/cancelRegisteredRobot', data)

export const submitRobotSdkReport = data => robotHttp.post('/user/robotSdkReport', data)

export const regenerateSdkBindingToken = (id, data) => robotHttp.post(`/user/registeredRobots/${id}/sdkBindingToken`, data)

export const confirmSdkDevice = (id, data) => robotHttp.post(`/user/registeredRobots/${id}/confirmSdkDevice`, data)

export const updateRobotAcceptingOrders = (id, data) => robotHttp.post(`/user/registeredRobots/${id}/acceptingOrders`, data)

export const getRobotArchive = (id, userId) => robotHttp.get(`/user/registeredRobots/${id}/archive`, { params: { userId } })

export const updateRobotArchive = (id, data) => robotHttp.put(`/user/registeredRobots/${id}/archive`, data)
